﻿/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/first';

import { AuthenticationService } from '../_services/index';


enum LoginView {
    LOGIN = 0,
    RESTORE_PASSWORD = 1
}
@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    model: any = {};
    loading = false;
    returnUrl: string;
    error = '';
    login_state: LoginView = LoginView.LOGIN;
    state_login: LoginView = LoginView.LOGIN;
    state_restore: LoginView = LoginView.RESTORE_PASSWORD;
   

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService) { }

    ngOnInit() {
        // reset login status
        this.authenticationService.logout();

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    login() {
        this.loading = true;
        this.authenticationService.login(this.model.username.trim(), this.model.password.trim())
            .first()
            .subscribe(
                data => {
                    if (this.authenticationService.isDistrubuidora()) {
                        this.router.navigate(["/distribuidora/home"]);
                    }else if (this.authenticationService.isMatriculado()) {
                        this.router.navigate([this.returnUrl]);
                    }
                },
                error => {
                    // if (error.status === 401 && error.error.mensaje !== undefined) {
                    //     this.error = error.error.mensaje;
                    // }else if (error.status === 400 && error.error.mensaje !== undefined) {
                    //     this.error = error.error.mensaje;
                    // }
                    if (error.error.mensaje !== undefined){
                        this.error = error.error.mensaje;
                    } else {
                        this.error = 'Error inesperado del servidor';
                    }
                    this.loading = false;
                });
    }

    restore_password() {
        this.login_state = LoginView.RESTORE_PASSWORD;
    }
}
